<template>
    <div>
        <navigation-menu-button
            @click="isMenuOpen = !isMenuOpen"
            :is-open="isMenuOpen"
        />

        <div
            :class="[
                `
                    fixed
                    lg:relative
                    top-0
                    left-0
                    flex
                    flex-1
                    flex-col
                    justify-center
                    lg:flex-row
                    lg:w-auto
                    lg:flex-0
                    lg:items-center
                    w-full
                    min-h-screen
                    lg:min-h-0
                    pt-6
                    lg:p-0
                    overflow-y-auto
                    lg:overflow-visible
                    pointer-events-none
                    lg:pointer-events-auto
                    navigation
                `,
                {
                    open: isMenuOpen,
                },
            ]"
        >
            <div
                ref="navigationContent"
                class="
                    relative
                    z-50
                    w-full
                    opacity-0
                    lg:opacity-100
                    navigation-content
                "
            >
                <slot />
            </div>

            <div
                ref="navigationBg"
                class="
                    fixed
                    top-0
                    right-0
                    lg:hidden
                    w-full
                    h-0
                    bg-secondary
                "
            />
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap';
import NavigationMenuButton from './menu-button.vue';

export default {
    name: 'NavigationMenu',
    components: {
        NavigationMenuButton,
    },
    data: () => ({
        isMenuOpen: false,
    }),
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.addEventListener('resieze', this.handleResize);
    },
    methods: {
        handleResize() {
            gsap.set([this.$refs.navigationBg, this.$refs.navigationContent], { clearProps: 'all' });

            this.isMenuOpen = false;
        },
    },
    watch: {
        isMenuOpen() {
            const timeline = gsap.timeline();

            if (this.isMenuOpen) {
                document.body.classList.add('menu-is-open');

                timeline.to(this.$refs.navigationBg, 0.5, {
                    height: '100%',
                });

                timeline.to(this.$refs.navigationContent, 0.3, {
                    opacity: 1,
                    translateY: 0,
                });

                return;
            }

            timeline.to(this.$refs.navigationContent, 0.3, {
                opacity: 0,
                translateY: -5,
            });

            timeline.to(this.$refs.navigationBg, 0.3, {
                height: 0,
            });

            document.body.classList.remove('menu-is-open');
        },
    },
};
</script>

<style lang="scss">
.menu-is-open {
    overflow: hidden;
}
</style>

<style lang="scss" scoped>
.navigation {
    &.open {
        pointer-events: all;
    }

    &-content {
        transform: translateY(-5px);

        @screen lg {
            transform: translateY(0);
        }
    }
}
</style>
